import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import { Link as RouterLink } from "react-router-dom";

// @material-ui/core components
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(theme => ({
    base: {
        textDecoration: 'none',
        fontSize: 'inherit',
        cursor: 'pointer',
    },
    primary: {
        color: theme.palette.primary.main,
        '&:hover, &.active': {
            color: theme.palette.primary.dark
        }
    },
    secondary: {
        color: theme.palette.secondary.main,
        '&:hover, &.active': {
            color: theme.palette.secondary.dark
        }
    },
    block: {
        display: 'block'
    },
    inlineBlock: {
        display: 'inline-block'
    },
    margin: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    large: {
        fontSize: '1.4em'
    },
    small: {
        fontSize: '.8em'
    }
}));

const Link = React.forwardRef((props, ref) => {
    const {
        color,
        children,
        block,
        size,
        margin,
        to,
        className,
        route,
        ...rest
    } = props;

    const classes = useStyles();

    const linkClasses = classNames({
        [classes.base]: true,
        [classes[color]]: color,
        [classes[block]]: block,
        [classes[size]]: size,
        [classes.margin]: margin,
        [className]: className
    });

    if (route) {
        return (
            <RouterLink to={to} ref={ref} className={linkClasses}>
                {children}
            </RouterLink>
        );
    } else {
        return (
            <a {...rest} href={to} ref={ref} className={linkClasses}>
                {children}
            </a>
        );
    }

});

Link.propTypes = {
    color: PropTypes.oneOf([
        "primary",
        "secondary",
    ]),
    block: PropTypes.oneOf([
        "block",
        "inlineBlock",
        "inline",
    ]),
    size: PropTypes.oneOf([
        "small",
        "large",
    ]),
    margin: PropTypes.bool,
    to: PropTypes.string.isRequired,
    children: PropTypes.node,
    className: PropTypes.string
};

export default Link;
